var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"overlay-area"},[_c('div',{staticClass:"overlay-content",class:{ 'overlay-content-disabled': _vm.isActive },style:(_vm.contentStyle)},[_vm._t("default")],2),(_vm.isActive)?_c('div',{staticClass:"overlay-mask",style:(_vm.maskStyle)},[_vm._t("overlay")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }